import {
  QueryKey,
  useInfiniteQuery,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  useQuery,
  UseQueryOptions,
} from 'react-query';
import { useAppScopeStore } from './store';

export function useScopedQuery<TQueryFnData, TError, TData = TQueryFnData, TQueryKey extends QueryKey = QueryKey>(
  arg: UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>
) {
  const { selectedLocationIds } = useAppScopeStore();
  const argCopy = { ...arg };
  const { queryKey } = argCopy;

  let key: any[] = [];
  if (typeof queryKey === 'string') {
    key = [queryKey];
  } else if (Array.isArray(queryKey)) {
    key = queryKey;
  }

  const localizedQueryKey: QueryKey = [selectedLocationIds, ...key];
  delete argCopy.queryKey;
  const modifiedArguments = {
    queryKey: localizedQueryKey,
    staleTime: 0,
    enabled: !!selectedLocationIds?.length && argCopy.enabled !== false,
    ...argCopy,
  } as typeof arg;

  const queryResult = useQuery(modifiedArguments);

  return {
    ...queryResult,
    queryKey,
  };
}

export function useScopedInfiniteQuery<
  TQueryFnData,
  TError,
  TData = TQueryFnData,
  TQueryKey extends QueryKey = QueryKey
>(
  arg: UseInfiniteQueryOptions<TQueryFnData, TError, TData, TQueryFnData, TQueryKey>
): UseInfiniteQueryResult<TData, TError> {
  const { selectedLocationIds } = useAppScopeStore();
  const { queryKey } = arg;

  let key: any[] = [];
  if (typeof queryKey === 'string') {
    key = [queryKey];
  } else if (Array.isArray(queryKey)) {
    key = queryKey;
  }

  const localizedQueryKey: QueryKey = [selectedLocationIds, ...key];
  delete arg.queryKey;
  const modifiedArguments = {
    queryKey: localizedQueryKey,
    staleTime: 0,
    ...arg,
  } as typeof arg;

  // @ts-ignore
  return useInfiniteQuery<TQueryFnData, TError, TData, TQueryKey>(modifiedArguments);
}
